// scoreMachine.js
import { createMachine } from 'xstate'
import { States, Events, Tags } from './scoreMachineConstants'
import { ScoreWithRef } from '../types'

function createScoreMachine(score: ScoreWithRef) {
  return createMachine({
    id: 'scoreAssistant',
    initial: score.status,
    context: {
      scoreData: null,
    },
    states: {
      [States.SCRAPED]: {
        tags: [],
        meta: {
          cssBorder: { border: '5px solid purple' }, // https://www.w3schools.com/cssref/css_colors.php
        },
        on: {
          // fake transitions.. handled by the detector in python
          DETECTOR_RESULT_1: States.CLASSIFIED,
          DETECTOR_RESULT_2: States.CLASSIFICATION_FAILED,
          DETECTOR_RESULT_3: States.NOT_RECOGNIZED,
          DETECTOR_RESULT_4: States.ERROR,
          DETECTOR_RESULT_5: States.DOWNLOAD_FAILED,
        }, // DETECTOR
      },
      [States.CLASSIFIED]: {
        // fake, auto_approval
        on: {
          AUTO_APPROVE: States.AUTO_APPROVED,
        },
      },
      [States.CLASSIFICATION_FAILED]: {
        tags: [Tags.ERROR, Tags.EDITABLE],
        meta: {
          cssBorder: { border: '5px solid orange' },
        },
        on: {
          [Events.EDIT]: States.EDITING,
          [Events.INVALIDATE]: States.INVALID_SCORE,
        },
      },
      [States.NOT_RECOGNIZED]: {
        tags: [Tags.ERROR, Tags.EDITABLE],
        meta: {
          cssBorder: { border: '5px solid orange' },
        },
        on: {
          [Events.EDIT]: States.EDITING,
          [Events.INVALIDATE]: States.INVALID_SCORE,
        },
      },
      [States.DOWNLOAD_FAILED]: {
        tags: [Tags.ERROR, Tags.EDITABLE],
        meta: {
          cssBorder: { border: '5px solid red' },
        },
        on: {
          [Events.EDIT]: States.EDITING,
          [Events.INVALIDATE]: States.INVALID_SCORE,
        },
      },
      [States.ERROR]: {
        tags: [Tags.ERROR, Tags.EDITABLE],
        meta: {
          cssBorder: { border: '5px solid red' },
        },
        on: {
          [Events.EDIT]: States.EDITING,
          [Events.INVALIDATE]: States.INVALID_SCORE,
        },
      },
      [States.INVALID_SCORE]: {
        tags: [Tags.FINAL, Tags.EDITABLE],
        meta: {
          cssBorder: { border: '5px solid grey' },
        },
        on: {
          [Events.EDIT]: States.EDITING,
        },
      },
      [States.EDITING]: {
        tags: [''], // case handled ad hoc with .matches
        meta: {
          cssBorder: { border: '5px solid yellow' },
        },
        on: {
          [Events.MANUALLY_APPROVE]: States.MANUALLY_APPROVED,
          [Events.INVALIDATE]: States.INVALID_SCORE,
        },
      },
      [States.AUTO_APPROVED]: {
        tags: [Tags.APPROVED, Tags.VALID, Tags.FINAL, Tags.EDITABLE],
        meta: {
          cssBorder: { border: '5px solid dodgerBlue' },
        },
        on: {
          [Events.EDIT]: States.EDITING,
          [Events.INVALIDATE]: States.INVALID_SCORE,
          // PUSH: {
          //   target: 'PUSHED',
          //   actions: sendToDatabase,
          // },
        },
      },
      [States.MANUALLY_APPROVED]: {
        tags: [Tags.APPROVED, Tags.VALID, Tags.FINAL, Tags.EDITABLE],
        meta: {
          cssBorder: { border: '5px solid dodgerBlue' },
        },
        on: {
          [Events.EDIT]: States.EDITING,
          [Events.INVALIDATE]: States.INVALID_SCORE,
          // PUSH: {
          //   target: 'PUSHED',
          //   actions: sendToDatabase,
          // },
        },
      },
      [States.PUSHED]: {
        tags: [Tags.APPROVED, Tags.VALID, Tags.FINAL],
        meta: {
          cssBorder: { border: '5px solid green' },
        },
        // the push will be set by gapps script
        // but you can remove the push state
        on: {
          [Events.RESET]: States.MANUALLY_APPROVED, // it's a remove pushed //TODO!!!! decide how to get the old state back, from firestore
        },
        type: 'final',
      },
      history: {
        type: 'history',
      },
    },
    on: {
      GO_BACK: '.history',
    },
  })
}

export default createScoreMachine
